import { SVGProps } from 'react';

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66441 0.252603C10.0771 0.619523 10.1143 1.25159 9.74741 1.66441L7.08076 4.66441L4.41411 7.66441C4.22431 7.87791 3.95231 8.00001 3.66671 8.00001C3.38101 8.00001 3.10901 7.87791 2.91927 7.66441L0.252603 4.66441C-0.114317 4.25161 -0.0771374 3.61951 0.335653 3.25261C0.748433 2.88571 1.3805 2.92291 1.74742 3.33561L3.66671 5.49481L8.25261 0.335653C8.61951 -0.0771374 9.25161 -0.114317 9.66441 0.252603Z"
        fill={fill || 'white'}
      />
    </svg>
  );
}
